import { SVG, getDefaultHeight } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const FontIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      height={getDefaultHeight(svgProps, 22)}
      {...svgProps}
    >
      <path
        d="M5.706 1H3a2 2 0 0 0-2 2v2.444M1 16.556V19a2 2 0 0 0 2 2h2.706M16.294 21H19a2 2 0 0 0 2-2v-2.444M21 5.444V3a2 2 0 0 0-2-2h-2.706"
        stroke={color ?? "currentColor"}
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M4.696 15H3.298L6.44 6.273H7.96L11.1 15H9.704L7.236 7.858h-.068L4.696 15Zm.234-3.418h4.535v1.108H4.93v-1.108ZM14.761 15.145c-.414 0-.79-.077-1.124-.23a1.895 1.895 0 0 1-.797-.678c-.194-.295-.29-.657-.29-1.086 0-.37.07-.674.213-.912.142-.239.334-.428.575-.567.242-.14.512-.244.81-.316a8.05 8.05 0 0 1 .912-.161l.954-.111c.245-.031.422-.081.533-.15.11-.067.166-.178.166-.332v-.03c0-.372-.105-.66-.315-.865-.208-.204-.517-.306-.93-.306-.428 0-.766.095-1.013.285a1.528 1.528 0 0 0-.508.627l-1.197-.273c.142-.398.35-.719.622-.963.276-.247.593-.426.95-.537a3.71 3.71 0 0 1 1.13-.17c.261 0 .538.03.83.093.296.06.572.17.828.332.258.162.47.394.634.695.165.298.248.686.248 1.163V15h-1.245v-.895h-.05a1.814 1.814 0 0 1-.372.486c-.164.159-.376.291-.635.396a2.463 2.463 0 0 1-.928.158Zm.277-1.023c.353 0 .654-.07.904-.209.253-.139.445-.32.575-.545.134-.227.2-.47.2-.729v-.843a.665.665 0 0 1-.264.127 4.11 4.11 0 0 1-.439.098c-.164.026-.325.05-.481.073l-.392.05a3.153 3.153 0 0 0-.678.159c-.201.073-.363.18-.486.32-.119.136-.179.317-.179.545 0 .315.117.554.35.716.233.159.53.238.89.238Z"
        fill={color ?? "currentColor"}
        stroke="none"
      />
    </SVG>
  );
};
